__turbopack_context__.v({
  "frame": "nRo8Ja_frame",
  "glyph": "nRo8Ja_glyph",
  "srOnly": "nRo8Ja_srOnly",
  "track": "nRo8Ja_track",
});
